/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { cellRendererSixDec } from '../../../../../../SharedModules/utilities/utilities';

const readOnlyStyle = {
  opacity: 0.85,
  pointerEvents: 'none',
  userSelect: 'none',
  cursor: 'default',
  width: '100%',
};

const PriceCustomComponent = (props) => {
  const { readOnly } = props;
  const content = cellRendererSixDec(props);

  if (!readOnly) {
    return content;
  }

  return <div style={readOnlyStyle}>{content}</div>;
};

export default PriceCustomComponent;
